/**
 *
 * Actions Service Sagas
 *
 */

import { take, call, put } from 'redux-saga/effects';
import { toastr } from 'react-redux-toastr';
import isObject from 'lodash/isObject';
import isFunction from 'lodash/isFunction';
import { updateAlreadyRequestedTransfer } from 'services/search';
import { ACTIONS_REQUEST } from './constants';
import { notAsked, loading, success, failure } from './actions';
import { actionRequest } from './api';
import { updateCurrentTransfer } from '../details/actions';


export function* requestFlow(transferId, body, actionType, successMessage, errorMessagePrefix) {
  // Set the status to LOADING and store the params
  yield put(loading(transferId, body));

  try {
    // Make the request
    const result = yield call(actionRequest, transferId, JSON.stringify(body), actionType);
    // Set the status to SUCCESS and store the result
    yield put(success(result));
    // Call search action to update the transfer data.
    yield put(updateAlreadyRequestedTransfer(transferId, result));
    // Call update current transfer
    yield put(updateCurrentTransfer(result));
    // Toast a success message
    yield call(toastr.success, successMessage);
  } catch (err) {
    let errorBody = err;
    if (isObject(err.response)) {
      if (isFunction(err.response.json)) {
        errorBody = yield err.response.json();
      }
      errorBody.status = err.response.status;
    } else {
      errorBody = `${errorMessagePrefix} ${errorBody.toString()}`;
    }
    // The .json() method turns the response body into a promise.
    // Set status to FAILURE and pass along the error
    yield put(failure(errorBody));
  }
}

export function* actionsServiceFlow() {
  // Set the initial status
  yield put(notAsked());

  while (true) {
    // Watch for ACTIONS_REQUEST to be dispatched
    const {
      body,
      transferId,
      successMessage,
      errorMessagePrefix,
      actionType,
    } = yield take(ACTIONS_REQUEST);

    // Make the request
    yield call(requestFlow, transferId, body, actionType, successMessage, errorMessagePrefix);
  }
}

export default [actionsServiceFlow()];



// WEBPACK FOOTER //
// ./src/services/actions/sagas.js